const getForm1262ReturningUserData = require("./getForm1262ReturningUserData");
const hideForm1262Form = require("./hideForm1262Form");
const showForm1262ReturningUser = require("./showForm1262ReturningUser");

/**
 * @returns {void}
 */
module.exports = function initForm1262ReturningUser() {
    const form1262ReturningUserData = getForm1262ReturningUserData();

    if (form1262ReturningUserData) {
        hideForm1262Form();
        showForm1262ReturningUser();
    }
};
